<template>
    <div id="right-sidebar-tabs">
        <span :class="{ selected: canUseColorGradingTools, '--disabled': !canUseColorGradingTools }"
              data-container="previews"
        >Previews</span>

        <div class="selector-slider"></div>
    </div>
</template>

<script>
import CanMixin from "@/mixins/CanMixin";
import { mapGetters, mapState } from "vuex";

export default {
    mixins: [CanMixin],

    computed: {
        ...mapGetters('User', ['isGuest']),
        ...mapState('Projects', ['image', 'currentFile']),
    }


};
</script>

<style lang="scss" scoped>
#right-sidebar-tabs {
    display: grid;
    grid-template-columns: repeat(3, auto);
    justify-content: center;
    align-items: center;
    padding: 2px 12px 0;
    height: var(--sidebar-tabs-height);
    z-index: 20;
    background-color: #121212;
    position: relative;
    padding-bottom: 10px;

    > span {
        position: relative;
        cursor: pointer;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        transition: all 0.05s ease;
        text-transform: uppercase;
        font-size: 12px;
        font-weight: bold;
        line-height: 18px;
        &:last-of-type {
            margin-right: 12px;
        }
    }

    > .selected {
        color: #fff;
        > .match-counter:before {
            border-color: #fff;
        }
    }

    .selector-slider {
        width: 75px;
        position: absolute;
        bottom: -1px;
        left: 0;
        transform: translateX(12px);
        background: var(--primary);
        height: 2px;
        transition: all 0.05s ease;
    }
}
</style>
